export default{
    myCollection: {
        Message: {
            delete: {
                success: 'Successfully deleted!', // 删除成功提示
            },
        },
        Alert: {
            error: {
                title: 'Notice', // 错误弹窗标题
                text: 'Data request failed. Please try again.', // 错误信息
                buttonText: 'OK' // 确认按钮
            }
        },
        Placeholder: {
            text1: 'Search by product name', // 商品搜索占位符
            text2: 'Search by store name' // 商家搜索占位符
        },
        Description: {
            noData: 'No data available', // 空状态提示
            more: 'View more', // 查看更多
            module1: {
                title: 'Products', // 商品模块标题
                item: {
                    text1: 'Total sales: ', // 累计销量
                    text2: ' orders' // 单位（笔）
                }
            },
            module2: {
                title: 'Stores', // 店铺模块标题
                item: {
                    text1: 'Contact: ', // 联系人
                    text2: 'Phone: ', // 手机号
                    text3: 'Location: ', // 所在地
                    text4: 'Email: ', // 邮箱
                    button1: 'Visit Store', // 进入店铺
                    button2: 'Unfollow' // 取消关注
                }
            },
            module3: {
                title: 'New Arrivals' // 新品推荐标题
            }
        },
        Confirm: {
            cancel: 'Cancel', // 取消按钮
            confirm: 'Confirm', // 确认按钮
            title: 'Delete Confirmation', // 删除弹窗标题
            text: 'Are you sure you want to delete this item?' // 删除确认提示
        }
    }
            
}